module.exports = __webpack_public_path__ + "img/authe-2.e4ff7a8.jpg";